<template>
	<section>
		<div v-if="showParentView('page-role')">
			<header-page
				name="roles"
				:title="$route.meta.title"
			/>
			<role-list
				:code-company="codeCompany"
				:code-project="codeProject"
				:columns="columns"
				:current-page="currentPage"
				:rows="table.rows"
				:last-page="table.lastPage"
				@change-page="changePage"
				@on-search="onSearch($event, `company/${codeCompany}/project/${codeProject}/role`)"
				@on-delete="loadData(`company/${codeCompany}/project/${codeProject}/role`)"
			/>
			<quick-actions
				:actions="actions"
				@open-modal="openModal"
			>
			</quick-actions>
		</div>
		<router-view></router-view>
	</section>
</template>

<script>
import quickActions from '@/components/shared/quick-actions';
import roleList from '@/components/roles/role-list';

function created() {
	this.loadData(`company/${this.codeCompany}/project/${this.codeProject}/role`);
}

function changePage(page) {
	this.params.page = page;
	this.currentPage = page;
	this.loadData(`company/${this.codeCompany}/project/${this.codeProject}/role`);
}

function openModal() {
	this.goTo('page-role-new', { params: { codeCompany: this.codeCompany, codeProject: this.codeProject } });
}

function data() {
	return {
		actions: [
			{
				id: 1,
				code: 'CR',
				text: 'Crear Rol',
				icon: 'group_add',
				active: true,
			},
		],
		columns: [
			{ id: 1, name: 'Id', checked: true, visible: true },
			{ id: 2, name: 'Nombre', checked: true, visible: true },
			{ id: 3, name: 'Acciones', checked: true, visible: true, flagVisible: true },
		],
		currentPage: 1,
	};
}

export default {
	name: 'page-role',
	created,
	components: {
		roleList,
		quickActions,
	},
	data,
	methods: {
		changePage,
		openModal,
	},
	props: {
		codeProject: {
			type: String,
		},
		codeCompany: {
			type: String,
		},
	},
	watch: {
		$route(newVal) {
			if (newVal) {
				if (newVal.name === 'page-role') {
					this.loadData(`company/${this.codeCompany}/project/${this.codeProject}/role`);
				}
			}
		},
	},
};
</script>



// WEBPACK FOOTER //
// src/pages/roles/page-role.vue